module.exports = __webpack_public_path__ + "053df6b921e7c0daf9175264ff4e964f.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/colorshop.png
// module id = 593
// module chunks = 0